<template>
    <div class="home-container">
        <nav-list :clickIndex="clickIndex"></nav-list>
        <div class="chart-two">
            <!-- <div class="line-chart">
                <div class="date-picker" style="width: 50%;">
                    <el-date-picker v-model="selectDate" type="daterange" range-separator="至" start-placeholder="开始日期"
                        end-placeholder="结束日期" value-format="yyyy-MM-dd" @change="getuseractivedata"
                        :picker-options="pickerOptions">
                    </el-date-picker>
                </div>
                <div id="dayActive" v-loading="loading" element-loading-text="加载中..."
                    element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.1)"
                    style="width: 100%;height: 100%;"></div>
            </div> -->
            <div class="line-chart" style="position: relative;">
                <div style="display: flex;justify-content: center;">
                    <div class="div_any_title" style="position: relative;z-index: 999;padding: 0 20px;top: 5px;left: 0;width: auto;">
                        <img src="../../assets/images/title_0.png" />
                        {{ !mapProvinciaShow && !mapCityShow ? '全国' : '' }}{{ mapProvinciaShow ? selectProvincia.name :
                            ''
                        }}{{ mapCityShow ? selectCity.name : '' }}开户分布图
                    </div>
                </div>

                <div id="mapChart" ref="mapChart" v-loading="loading" element-loading-text="地图正在生成中"
                    element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.1)"
                    style="width: 100%;height: 100%;"></div>

                <div v-if="mapProvinciaShow" class="map_provincia_show"
                    style="margin: 0;width: calc((100vw - 30px - 15px) / 2);background-color: #081832;">
                    <div ref="mapProvincia" v-loading="tableLoading" element-loading-text="地图正在生成中"
                        element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.05)"
                        style="display: inline-block;width: 100%;height: calc(100vh - 160px) !important;padding: 22px 0 0;">
                    </div>
                </div>
                <div v-if="mapCityShow" class="map_provincia_show"
                    style="margin: 0;width: calc((100vw - 30px - 15px) / 2);background-color: #081832;">
                    <div ref="mapCity" id="mapCity" v-loading="tableLoading2" element-loading-text="地图正在生成中"
                        element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.05)"
                        style="display: inline-block;width: 100%;height: calc(100vh - 160px) !important;padding: 22px 0 0;">
                    </div>
                </div>
                <i v-if="mapProvinciaShow" class="el-icon-close close-botton" @click="closeMap"></i>
            </div>

            <div class="line-chart">
                <div class="top-select" style="justify-content: flex-start;">
                    <div class="date-picker" >
                        <el-date-picker v-model="selectDate2" type="daterange" range-separator="至"
                            start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"
                            @change="getMonList" :picker-options="pickerOptions2">
                        </el-date-picker>
                    </div>
                    <!-- <div style="width: 50%; margin-left: 10px;">
                        <el-cascader clearable v-model="cityValue" :options="flattenedOptions" :show-all-levels="false"
                            :props="cityProps" @change="cityChange">
                        </el-cascader>
                    </div> -->
                </div>
                <div id="monActive" v-loading="loading2" element-loading-text="加载中..."
                    element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.1)"
                    style="width: 100%;flex: 1;padding-top: 10px;"></div>
            </div>
        </div>
    </div>
</template>
<script>
import {
    getScreenIndex,
    getUserData,
    getKaihuList,
    getKaihuCityList,
    getCityList,
    getiptoprovince,
    getMapCityIndex,
    getCityBankData_new,
    get_bank_type,
    getMapJson
} from "@/api/homeIndex/homeIndex";
import navList from "@/components/navList/navList.vue";


import Provincia11 from "@/assets/json/geometryProvince/11.json";
import Provincia12 from "@/assets/json/geometryProvince/12.json";
import Provincia13 from "@/assets/json/geometryProvince/13.json";
import Provincia14 from "@/assets/json/geometryProvince/14.json";
import Provincia15 from "@/assets/json/geometryProvince/15.json";
import Provincia21 from "@/assets/json/geometryProvince/21.json";
import Provincia22 from "@/assets/json/geometryProvince/22.json";
import Provincia23 from "@/assets/json/geometryProvince/23.json";
import Provincia31 from "@/assets/json/geometryProvince/31.json";
import Provincia32 from "@/assets/json/geometryProvince/32.json";
import Provincia33 from "@/assets/json/geometryProvince/33.json";
import Provincia34 from "@/assets/json/geometryProvince/34.json";
import Provincia35 from "@/assets/json/geometryProvince/35.json";
import Provincia36 from "@/assets/json/geometryProvince/36.json";
import Provincia37 from "@/assets/json/geometryProvince/37.json";
import Provincia41 from "@/assets/json/geometryProvince/41.json";
import Provincia42 from "@/assets/json/geometryProvince/42.json";
import Provincia43 from "@/assets/json/geometryProvince/43.json";
import Provincia44 from "@/assets/json/geometryProvince/44.json";
import Provincia45 from "@/assets/json/geometryProvince/45.json";
import Provincia46 from "@/assets/json/geometryProvince/46.json";
import Provincia50 from "@/assets/json/geometryProvince/50.json";
import Provincia51 from "@/assets/json/geometryProvince/51.json";
import Provincia52 from "@/assets/json/geometryProvince/52.json";
import Provincia53 from "@/assets/json/geometryProvince/53.json";
import Provincia54 from "@/assets/json/geometryProvince/54.json";
import Provincia61 from "@/assets/json/geometryProvince/61.json";
import Provincia62 from "@/assets/json/geometryProvince/62.json";
import Provincia63 from "@/assets/json/geometryProvince/63.json";
import Provincia64 from "@/assets/json/geometryProvince/64.json";
import Provincia65 from "@/assets/json/geometryProvince/65.json";
import Provincia71 from "@/assets/json/geometryProvince/71.json";
import Provincia81 from "@/assets/json/geometryProvince/81.json";
import Provincia82 from "@/assets/json/geometryProvince/82.json";
import { cityMap } from '@/assets/json/geometryCity/china-main-city-map.js'
import china from "@/assets/json/china.json";
import region from "@/assets/json/region.json";
import {
    getDayActiveList,
    getMonActiveList
} from "@/api/inviteIndex/inviteIndex";
import "echarts/extension/bmap/bmap";
export default {
    name: "homeIndex",
    components: {
        navList
    },
    data() {
        return {
            cityProps: {
                value: 'name',
                label: 'name',
                children: 'cities'
            },
            cityValue: '合肥市',
            selectDate: "",
            selectDate2: '',
            // 日期时间范围在一个月以内
            pickerOptions: {
                onPick: ({ maxDate, minDate }) => {
                    this.selectDate = minDate.getTime();
                    if (minDate && !maxDate) {
                        this.timeOptionRange = minDate;
                    }
                    if (maxDate) {
                        this.selectDate = "";
                        this.timeOptionRange = null;
                    }
                },
                disabledDate: (time) => {
                    let timeOptionRange = this.timeOptionRange;
                    if (
                        timeOptionRange &&
                        time.getTime() === timeOptionRange.getTime()
                    )
                        return true;
                    if (this.selectDate !== "") {
                        const one = 30 * 24 * 3600 * 1000;
                        const minTime = this.selectDate - one;
                        const maxTime = this.selectDate + one;
                        return (
                            time.getTime() < minTime || time.getTime() > maxTime
                        );
                    }
                },
            },

            pickerOptions2: {
                onPick: ({ maxDate, minDate }) => {
                    this.selectDate2 = minDate.getTime();
                    if (minDate && !maxDate) {
                        this.timeOptionRange = minDate;
                    }
                    if (maxDate) {
                        this.selectDate2 = "";
                        this.timeOptionRange = null;
                    }
                },
                disabledDate: (time) => {
                    let timeOptionRange = this.timeOptionRange;
                    if (
                        timeOptionRange &&
                        time.getTime() === timeOptionRange.getTime()
                    )
                        return true;
                    if (this.selectDate2 !== "") {
                        const one = 30 * 24 * 3600 * 1000;
                        const minTime = this.selectDate2 - one;
                        const maxTime = this.selectDate2 + one;
                        return (
                            time.getTime() < minTime || time.getTime() > maxTime
                        );
                    }
                },
            },
            clickIndex: 2,

            indexObj: {},
            pickerTime: "",
            loading: true,
            loading2: true,
            topData: [],
            dataType: "",
            scrollView: false,
            lineOpiton: {
                title: {
                    text: "",
                },
                tooltip: {
                    trigger: "axis",
                },
                legend: {
                    data: ["预约量", "完成量"],
                    textStyle: {
                        color: "#fff",
                    },
                    left: "3%"
                },
                grid: {
                    left: "3%",
                    right: "4%",
                    bottom: "3%",
                    containLabel: true,
                },

                xAxis: {
                    type: "category",
                    boundaryGap: false,
                    data: [],
                    axisLabel: {
                        textStyle: {
                            color: "#fff",
                        },
                    },
                },
                yAxis: {
                    type: "value",
                    axisLabel: {
                        textStyle: {
                            color: "#fff",
                        },
                    },
                },
                series: [
                    {
                        name: "预约量",
                        type: "line",
                        stack: "yuyue",
                        data: [],
                    },
                    {
                        name: "完成量",
                        type: "line",
                        stack: "deal",
                        data: [],
                    }
                ],
            },

            lineOpiton2: {
                title: {
                    text: "",
                },
                tooltip: {
                    trigger: "axis",
                },
                legend: {
                    data: ["预约量", "完成量"],
                    textStyle: {
                        color: "#fff",
                    },
                    left: "3%"
                },
                grid: {
                    left: "3%",
                    right: "4%",
                    bottom: "3%",
                    containLabel: true,
                },

                xAxis: {
                    type: "category",
                    boundaryGap: false,
                    data: [],
                    axisLabel: {
                        textStyle: {
                            color: "#fff",
                        },
                    },
                },
                yAxis: {
                    type: "value",
                    axisLabel: {
                        textStyle: {
                            color: "#fff",
                        },
                    },
                },
                series: [
                    {
                        name: "预约量",
                        type: "line",
                        stack: "yuyue",
                        data: [],
                    },
                    // {
                    //     name: "完成量",
                    //     type: "line",
                    //     stack: "deal",
                    //     data: [],
                    // }
                ],
            },

            regionData: [],

            topData: [],
            myChart: null,
            mapProvinciaShow: false,
            mapCityShow: false,
            myChartProvincia: null,
            myChartCtiy: null,
            dialogTableVisible4: false,
            dialogTableVisible5: false,
            selectProvincia: {},
            selectCity: {},
            dialogTableVisible: false,
            provinceList: [],
            dialogType: 1,
            tableLoading: true,
            tableLoading2: true,

            provinciaList: {
                北京: Provincia11,
                天津: Provincia12,
                河北: Provincia13,
                山西: Provincia14,
                内蒙古: Provincia15,
                辽宁: Provincia21,
                吉林: Provincia22,
                黑龙江: Provincia23,
                上海: Provincia31,
                江苏: Provincia32,
                浙江: Provincia33,
                安徽: Provincia34,
                福建: Provincia35,
                江西: Provincia36,
                山东: Provincia37,
                河南: Provincia41,
                湖北: Provincia42,
                湖南: Provincia43,
                广东: Provincia44,
                广西: Provincia45,
                海南: Provincia46,
                重庆: Provincia50,
                四川: Provincia51,
                贵州: Provincia52,
                云南: Provincia53,
                西藏: Provincia54,
                陕西: Provincia61,
                甘肃: Provincia62,
                青海: Provincia63,
                宁夏: Provincia64,
                新疆: Provincia65,
                台湾: Provincia71,
                香港: Provincia81,
                澳门: Provincia82
            },

            cityOptions: {
                title: {
                    text: '',
                    top: '8%',
                    left: '8%',
                    textStyle: {
                        fontSize: 14,
                        fontWeight: 300,
                        color: '#000'
                    }
                },
                tooltip: {
                    triggerOn: "mousemove", //mousemove、click
                    padding: 8,
                    borderWidth: 1,
                    borderColor: "#409eff",
                    backgroundColor: "rgba(255,255,255,0.7)",
                    textStyle: {
                        color: "#000000",
                        fontSize: 13,
                    },
                    // 数据格式化
                    formatter: function (e, t, n) {
                        let data = e.data;
                        let context = `
                            <div>
                                <p><b style="font-size:15px;">${data.name}</b></p>
                                <p class="tooltip_style"><span class="tooltip_left">开户数量：</span><span class="tooltip_right">${data.value[2]}</span></p>
                            </div>
                            `;
                        return context;
                    },
                },
                legend: {
                    textStyle: {
                        color: '#ffffff',
                    },
                    data: []
                },
                // legend: {
                //     orient: 'vertical',
                //     top: '9%',
                //     left: '5%',
                //     icon: 'circle',
                //     data: [],
                //     selectedMode: 'single',
                //     selected: {},
                //     itemWidth: 12,
                //     itemHeight: 12,
                //     itemGap: 30,
                //     inactiveColor: '#b6d7ff',
                //     textStyle: {
                //         color: '#ec808d',
                //         fontSize: 14,
                //         fontWeight: 300,
                //         padding: [0, 0, 0, 15]
                //     }
                // },
                // visualMap: {

                // },
                geo: {
                    map: '',
                    roam: true, // 不开启缩放和平移
                    zoom: 1.2, // 视角缩放比例
                    layoutSize: "100%", //保持地图宽高比
                    label: {
                        normal: {
                            show: true,
                            fontSize: 10,
                            color: '#fff'
                        },
                        emphasis: {
                            show: false,
                            color: 'blue',
                        }
                    },
                    itemStyle: {
                        areaColor: '#7ED3FF',
                        // normal: {
                        //     borderColor: 'rgba(0, 0, 0, 0.2)'
                        // },
                        // emphasis: {
                        //     disabled: true,
                        //     areaColor: '#1C95FF', // 鼠标选择区域颜色
                        //     shadowOffsetX: 0,
                        //     shadowOffsetY: 0,
                        //     shadowBlur: 0,
                        //     borderWidth: 0
                        // }
                    },
                    emphasis: {
                        disabled: true,
                        label: {
                            show: false
                        }
                    }
                },
                series: [],
                cityJSON: {},
                cityName: '',

                bankDictionary: null
            }

        };
    },
    computed: {
        flattenedOptions() {
            return this.regionData.map(province => {
                // 深拷贝第一级
                const provinceClone = { ...province };

                // 处理第二级：移除第三级children
                if (provinceClone.cities) {
                    provinceClone.cities = provinceClone.cities.map(city => ({
                        id: city.id,
                        name: city.name
                        // 不保留children属性，第三级自动隐藏
                    }));
                }

                return provinceClone;
            });
        },
    },
    watch: {},
    created() {
        let startDate = this.$moment().format("YYYY-MM-DD");
        let endDate = this.$moment().add(0, "days").format("YYYY-MM-DD");
        let monDate = this.$moment().subtract(1, "months").format("YYYY-MM-DD");
        this.pickerTime = [startDate, endDate];
        this.selectDate = [monDate, startDate];
        this.selectDate2 = [monDate, startDate]
        this.getCityListData()
    },
    mounted() {
        this.$nextTick(() => {
            this.getMap();
            // this.getuseractivedata();
            this.getMonList();
        });
        this.getWebSocket();
        this.get_bank_type()
    },

    props: [],
    methods: {
















        async get_bank_type() {
            const res = await get_bank_type({})
            if (res.data.code == 1) {
                let obj = {}
                for (let item of res.data.data) {
                    if (item.code) {
                        this.cityOptions.legend.data.push(item.name)
                        obj[item.code] = {
                            name: item.name,
                            code: item.code,
                            color: item.color
                        }
                    }
                }
                this.bankDictionary = obj
            }
        },

        getMap() {
            let params = {}
            if (this.selectDate2 && this.selectDate2.length > 0) {
                params.start_date = this.selectDate2[0]
                params.end_date = this.selectDate2[1]
            }
            getiptoprovince(params).then((res) => {
                console.log(res, 'resresres')
                let arr = [];
                for (let val in res.data.data) {
                    console.log(res.data.data[val], 'res.data.data[val].province_data')
                    let obj = {
                        name: res.data.data[val].province,
                        value: res.data.data[val].company_count,
                        total_companies: res.data.data[val].total_companies,
                        total_companycount: res.data.data[val].total_companycount,
                        total_individuals: res.data.data[val].total_individuals,
                        total_register: res.data.data[val].total_register,
                        bank_unit_price: res.data.data[val].bank_unit_price,
                        total_company_profit: res.data.data[val].total_company_profit,
                        total_income: res.data.data[val].total_income,
                        total_money: res.data.data[val].total_money,
                        unit_cost: res.data.data[val].unit_cost,
                        unit_profit: res.data.data[val].unit_profit,

                        total_partner_money: res.data.data[val].total_partner_money,
                        total_netprofit: res.data.data[val].total_netprofit,
                        cac: res.data.data[val].cac,
                        cpc: res.data.data[val].cpc,
                        total_sales_personnel_cost: res.data.data[val].total_sales_personnel_cost,
                        total_related_expenses: res.data.data[val].total_related_expenses,
                        total_customer_personnel_cost: res.data.data[val].total_customer_personnel_cost,
                        total_operating_cost: res.data.data[val].total_operating_cost,
                        net_profit: res.data.data[val].net_profit

                    };
                    arr.push(obj);
                }
                arr.push(
                    {
                        name: "台湾", value: 0,
                        total_companies: 0,
                        total_companycount: 0,
                        total_individuals: 0,
                        total_register: 0,
                        bank_unit_price: 0,
                        total_company_profit: 0,
                        total_income: 0,
                        total_money: 0,
                        unit_cost: 0,
                        unit_profit: 0, total_partner_money: 0,
                        total_netprofit: 0,
                        cac: 0,
                        cpc: 0,
                        total_sales_personnel_cost: 0,
                        total_related_expenses: 0,
                        total_customer_personnel_cost: 0,
                        total_operating_cost: 0,
                        net_profit: 0
                    },
                    {
                        name: "南海诸岛",
                        value: 0,
                        total_companies: 0,
                        total_companycount: 0,
                        total_individuals: 0,
                        total_register: 0,
                        bank_unit_price: 0,
                        total_company_profit: 0,
                        total_income: 0,
                        total_money: 0,
                        unit_cost: 0,
                        unit_profit: 0,
                        total_partner_money: 0,
                        total_netprofit: 0,
                        cac: 0,
                        cpc: 0,
                        total_sales_personnel_cost: 0,
                        total_related_expenses: 0,
                        total_customer_personnel_cost: 0,
                        total_operating_cost: 0,
                        net_profit: 0
                    },
                    {
                        name: "上海",
                        value: 0,
                        total_companies: 0,
                        total_companycount: 0,
                        total_individuals: 0,
                        total_register: 0,
                        bank_unit_price: 0,
                        total_company_profit: 0,
                        total_income: 0,
                        total_money: 0,
                        unit_cost: 0,
                        unit_profit: 0, total_partner_money: 0,
                        total_netprofit: 0,
                        cac: 0,
                        cpc: 0,
                        total_sales_personnel_cost: 0,
                        total_related_expenses: 0,
                        total_customer_personnel_cost: 0,
                        total_operating_cost: 0,
                        net_profit: 0
                    },
                    {
                        name: "湖北",
                        value: 0,
                        total_companies: 0,
                        total_companycount: 0,
                        total_individuals: 0,
                        total_register: 0,
                        bank_unit_price: 0,
                        total_company_profit: 0,
                        total_income: 0,
                        total_money: 0,
                        unit_cost: 0,
                        unit_profit: 0, total_partner_money: 0,
                        total_netprofit: 0,
                        cac: 0,
                        cpc: 0,
                        total_sales_personnel_cost: 0,
                        total_related_expenses: 0,
                        total_customer_personnel_cost: 0,
                        total_operating_cost: 0,
                        net_profit: 0
                    },
                    {
                        name: "云南", value: 0,
                        total_companies: 0,
                        total_companycount: 0,
                        total_individuals: 0,
                        total_register: 0,
                        bank_unit_price: 0,
                        total_company_profit: 0,
                        total_income: 0,
                        total_money: 0,
                        unit_cost: 0,
                        unit_profit: 0, total_partner_money: 0,
                        total_netprofit: 0,
                        cac: 0,
                        cpc: 0,
                        total_sales_personnel_cost: 0,
                        total_related_expenses: 0,
                        total_customer_personnel_cost: 0,
                        total_operating_cost: 0,
                        net_profit: 0
                    },
                    {
                        name: "内蒙古", value: 0,
                        total_companies: 0,
                        total_companycount: 0,
                        total_individuals: 0,
                        total_register: 0,
                        bank_unit_price: 0,
                        total_company_profit: 0,
                        total_income: 0,
                        total_money: 0,
                        unit_cost: 0,
                        unit_profit: 0, total_partner_money: 0,
                        total_netprofit: 0,
                        cac: 0,
                        cpc: 0,
                        total_sales_personnel_cost: 0,
                        total_related_expenses: 0,
                        total_customer_personnel_cost: 0,
                        total_operating_cost: 0,
                        net_profit: 0
                    },
                    {
                        name: "北京", value: 0,
                        total_companies: 0,
                        total_companycount: 0,
                        total_individuals: 0,
                        total_register: 0,
                        bank_unit_price: 0,
                        total_company_profit: 0,
                        total_income: 0,
                        total_money: 0,
                        unit_cost: 0,
                        unit_profit: 0, total_partner_money: 0,
                        total_netprofit: 0,
                        cac: 0,
                        cpc: 0,
                        total_sales_personnel_cost: 0,
                        total_related_expenses: 0,
                        total_customer_personnel_cost: 0,
                        total_operating_cost: 0,
                        net_profit: 0
                    },
                    {
                        name: "吉林", value: 0,
                        total_companies: 0,
                        total_companycount: 0,
                        total_individuals: 0,
                        total_register: 0,
                        bank_unit_price: 0,
                        total_company_profit: 0,
                        total_income: 0,
                        total_money: 0,
                        unit_cost: 0,
                        unit_profit: 0, total_partner_money: 0,
                        total_netprofit: 0,
                        cac: 0,
                        cpc: 0,
                        total_sales_personnel_cost: 0,
                        total_related_expenses: 0,
                        total_customer_personnel_cost: 0,
                        total_operating_cost: 0,
                        net_profit: 0
                    },
                    {
                        name: "天津", value: 0,
                        total_companies: 0,
                        total_companycount: 0,
                        total_individuals: 0,
                        total_register: 0,
                        bank_unit_price: 0,
                        total_company_profit: 0,
                        total_income: 0,
                        total_money: 0,
                        unit_cost: 0,
                        unit_profit: 0, total_partner_money: 0,
                        total_netprofit: 0,
                        cac: 0,
                        cpc: 0,
                        total_sales_personnel_cost: 0,
                        total_related_expenses: 0,
                        total_customer_personnel_cost: 0,
                        total_operating_cost: 0,
                        net_profit: 0
                    },
                    {
                        name: "宁夏", value: 0,
                        total_companies: 0,
                        total_companycount: 0,
                        total_individuals: 0,
                        total_register: 0,
                        bank_unit_price: 0,
                        total_company_profit: 0,
                        total_income: 0,
                        total_money: 0,
                        unit_cost: 0,
                        unit_profit: 0, total_partner_money: 0,
                        total_netprofit: 0,
                        cac: 0,
                        cpc: 0,
                        total_sales_personnel_cost: 0,
                        total_related_expenses: 0,
                        total_customer_personnel_cost: 0,
                        total_operating_cost: 0,
                        net_profit: 0
                    },
                    {
                        name: "山东", value: 0,
                        total_companies: 0,
                        total_companycount: 0,
                        total_individuals: 0,
                        total_register: 0,
                        bank_unit_price: 0,
                        total_company_profit: 0,
                        total_income: 0,
                        total_money: 0,
                        unit_cost: 0,
                        unit_profit: 0, total_partner_money: 0,
                        total_netprofit: 0,
                        cac: 0,
                        cpc: 0,
                        total_sales_personnel_cost: 0,
                        total_related_expenses: 0,
                        total_customer_personnel_cost: 0,
                        total_operating_cost: 0,
                        net_profit: 0
                    },
                    {
                        name: "山西", value: 0,
                        total_companies: 0,
                        total_companycount: 0,
                        total_individuals: 0,
                        total_register: 0,
                        bank_unit_price: 0,
                        total_company_profit: 0,
                        total_income: 0,
                        total_money: 0,
                        unit_cost: 0,
                        unit_profit: 0, total_partner_money: 0,
                        total_netprofit: 0,
                        cac: 0,
                        cpc: 0,
                        total_sales_personnel_cost: 0,
                        total_related_expenses: 0,
                        total_customer_personnel_cost: 0,
                        total_operating_cost: 0,
                        net_profit: 0
                    },
                    {
                        name: "广东", value: 0,
                        total_companies: 0,
                        total_companycount: 0,
                        total_individuals: 0,
                        total_register: 0,
                        bank_unit_price: 0,
                        total_company_profit: 0,
                        total_income: 0,
                        total_money: 0,
                        unit_cost: 0,
                        unit_profit: 0, total_partner_money: 0,
                        total_netprofit: 0,
                        cac: 0,
                        cpc: 0,
                        total_sales_personnel_cost: 0,
                        total_related_expenses: 0,
                        total_customer_personnel_cost: 0,
                        total_operating_cost: 0,
                        net_profit: 0
                    },
                    {
                        name: "广西", value: 0,
                        total_companies: 0,
                        total_companycount: 0,
                        total_individuals: 0,
                        total_register: 0,
                        bank_unit_price: 0,
                        total_company_profit: 0,
                        total_income: 0,
                        total_money: 0,
                        unit_cost: 0,
                        unit_profit: 0, total_partner_money: 0,
                        total_netprofit: 0,
                        cac: 0,
                        cpc: 0,
                        total_sales_personnel_cost: 0,
                        total_related_expenses: 0,
                        total_customer_personnel_cost: 0,
                        total_operating_cost: 0,
                        net_profit: 0
                    },
                    {
                        name: "新疆", value: 0,
                        total_companies: 0,
                        total_companycount: 0,
                        total_individuals: 0,
                        total_register: 0,
                        bank_unit_price: 0,
                        total_company_profit: 0,
                        total_income: 0,
                        total_money: 0,
                        unit_cost: 0,
                        unit_profit: 0, total_partner_money: 0,
                        total_netprofit: 0,
                        cac: 0,
                        cpc: 0,
                        total_sales_personnel_cost: 0,
                        total_related_expenses: 0,
                        total_customer_personnel_cost: 0,
                        total_operating_cost: 0,
                        net_profit: 0
                    },
                    {
                        name: "江苏", value: 0,
                        total_companies: 0,
                        total_companycount: 0,
                        total_individuals: 0,
                        total_register: 0,
                        bank_unit_price: 0,
                        total_company_profit: 0,
                        total_income: 0,
                        total_money: 0,
                        unit_cost: 0,
                        unit_profit: 0, total_partner_money: 0,
                        total_netprofit: 0,
                        cac: 0,
                        cpc: 0,
                        total_sales_personnel_cost: 0,
                        total_related_expenses: 0,
                        total_customer_personnel_cost: 0,
                        total_operating_cost: 0,
                        net_profit: 0
                    },
                    {
                        name: "江西", value: 0,
                        total_companies: 0,
                        total_companycount: 0,
                        total_individuals: 0,
                        total_register: 0,
                        bank_unit_price: 0,
                        total_company_profit: 0,
                        total_income: 0,
                        total_money: 0,
                        unit_cost: 0,
                        unit_profit: 0, total_partner_money: 0,
                        total_netprofit: 0,
                        cac: 0,
                        cpc: 0,
                        total_sales_personnel_cost: 0,
                        total_related_expenses: 0,
                        total_customer_personnel_cost: 0,
                        total_operating_cost: 0,
                        net_profit: 0
                    },
                    {
                        name: "河北", value: 0,
                        total_companies: 0,
                        total_companycount: 0,
                        total_individuals: 0,
                        total_register: 0,
                        bank_unit_price: 0,
                        total_company_profit: 0,
                        total_income: 0,
                        total_money: 0,
                        unit_cost: 0,
                        unit_profit: 0, total_partner_money: 0,
                        total_netprofit: 0,
                        cac: 0,
                        cpc: 0,
                        total_sales_personnel_cost: 0,
                        total_related_expenses: 0,
                        total_customer_personnel_cost: 0,
                        total_operating_cost: 0,
                        net_profit: 0
                    },
                    {
                        name: "河南", value: 0,
                        total_companies: 0,
                        total_companycount: 0,
                        total_individuals: 0,
                        total_register: 0,
                        bank_unit_price: 0,
                        total_company_profit: 0,
                        total_income: 0,
                        total_money: 0,
                        unit_cost: 0,
                        unit_profit: 0, total_partner_money: 0,
                        total_netprofit: 0,
                        cac: 0,
                        cpc: 0,
                        total_sales_personnel_cost: 0,
                        total_related_expenses: 0,
                        total_customer_personnel_cost: 0,
                        total_operating_cost: 0,
                        net_profit: 0
                    },
                    {
                        name: "浙江", value: 0,
                        total_companies: 0,
                        total_companycount: 0,
                        total_individuals: 0,
                        total_register: 0,
                        bank_unit_price: 0,
                        total_company_profit: 0,
                        total_income: 0,
                        total_money: 0,
                        unit_cost: 0,
                        unit_profit: 0, total_partner_money: 0,
                        total_netprofit: 0,
                        cac: 0,
                        cpc: 0,
                        total_sales_personnel_cost: 0,
                        total_related_expenses: 0,
                        total_customer_personnel_cost: 0,
                        total_operating_cost: 0,
                        net_profit: 0
                    },
                    {
                        name: "海南", value: 0,
                        total_companies: 0,
                        total_companycount: 0,
                        total_individuals: 0,
                        total_register: 0,
                        bank_unit_price: 0,
                        total_company_profit: 0,
                        total_income: 0,
                        total_money: 0,
                        unit_cost: 0,
                        unit_profit: 0, total_partner_money: 0,
                        total_netprofit: 0,
                        cac: 0,
                        cpc: 0,
                        total_sales_personnel_cost: 0,
                        total_related_expenses: 0,
                        total_customer_personnel_cost: 0,
                        total_operating_cost: 0,
                        net_profit: 0
                    },
                    {
                        name: "湖南", value: 0,
                        total_companies: 0,
                        total_companycount: 0,
                        total_individuals: 0,
                        total_register: 0,
                        bank_unit_price: 0,
                        total_company_profit: 0,
                        total_income: 0,
                        total_money: 0,
                        unit_cost: 0,
                        unit_profit: 0, total_partner_money: 0,
                        total_netprofit: 0,
                        cac: 0,
                        cpc: 0,
                        total_sales_personnel_cost: 0,
                        total_related_expenses: 0,
                        total_customer_personnel_cost: 0,
                        total_operating_cost: 0,
                        net_profit: 0
                    },
                    {
                        name: "甘肃", value: 0,
                        total_companies: 0,
                        total_companycount: 0,
                        total_individuals: 0,
                        total_register: 0,
                        bank_unit_price: 0,
                        total_company_profit: 0,
                        total_income: 0,
                        total_money: 0,
                        unit_cost: 0,
                        unit_profit: 0, total_partner_money: 0,
                        total_netprofit: 0,
                        cac: 0,
                        cpc: 0,
                        total_sales_personnel_cost: 0,
                        total_related_expenses: 0,
                        total_customer_personnel_cost: 0,
                        total_operating_cost: 0,
                        net_profit: 0
                    },
                    {
                        name: "福建", value: 0,
                        total_companies: 0,
                        total_companycount: 0,
                        total_individuals: 0,
                        total_register: 0,
                        bank_unit_price: 0,
                        total_company_profit: 0,
                        total_income: 0,
                        total_money: 0,
                        unit_cost: 0,
                        unit_profit: 0, total_partner_money: 0,
                        total_netprofit: 0,
                        cac: 0,
                        cpc: 0,
                        total_sales_personnel_cost: 0,
                        total_related_expenses: 0,
                        total_customer_personnel_cost: 0,
                        total_operating_cost: 0,
                        net_profit: 0
                    },
                    {
                        name: "西藏", value: 0,
                        total_companies: 0,
                        total_companycount: 0,
                        total_individuals: 0,
                        total_register: 0,
                        bank_unit_price: 0,
                        total_company_profit: 0,
                        total_income: 0,
                        total_money: 0,
                        unit_cost: 0,
                        unit_profit: 0, total_partner_money: 0,
                        total_netprofit: 0,
                        cac: 0,
                        cpc: 0,
                        total_sales_personnel_cost: 0,
                        total_related_expenses: 0,
                        total_customer_personnel_cost: 0,
                        total_operating_cost: 0,
                        net_profit: 0
                    },
                    {
                        name: "贵州", value: 0,
                        total_companies: 0,
                        total_companycount: 0,
                        total_individuals: 0,
                        total_register: 0,
                        bank_unit_price: 0,
                        total_company_profit: 0,
                        total_income: 0,
                        total_money: 0,
                        unit_cost: 0,
                        unit_profit: 0, total_partner_money: 0,
                        total_netprofit: 0,
                        cac: 0,
                        cpc: 0,
                        total_sales_personnel_cost: 0,
                        total_related_expenses: 0,
                        total_customer_personnel_cost: 0,
                        total_operating_cost: 0,
                        net_profit: 0
                    },
                    {
                        name: "辽宁", value: 0,
                        total_companies: 0,
                        total_companycount: 0,
                        total_individuals: 0,
                        total_register: 0,
                        bank_unit_price: 0,
                        total_company_profit: 0,
                        total_income: 0,
                        total_money: 0,
                        unit_cost: 0,
                        unit_profit: 0, total_partner_money: 0,
                        total_netprofit: 0,
                        cac: 0,
                        cpc: 0,
                        total_sales_personnel_cost: 0,
                        total_related_expenses: 0,
                        total_customer_personnel_cost: 0,
                        total_operating_cost: 0,
                        net_profit: 0
                    },
                    {
                        name: "重庆", value: 0,
                        total_companies: 0,
                        total_companycount: 0,
                        total_individuals: 0,
                        total_register: 0,
                        bank_unit_price: 0,
                        total_company_profit: 0,
                        total_income: 0,
                        total_money: 0,
                        unit_cost: 0,
                        unit_profit: 0, total_partner_money: 0,
                        total_netprofit: 0,
                        cac: 0,
                        cpc: 0,
                        total_sales_personnel_cost: 0,
                        total_related_expenses: 0,
                        total_customer_personnel_cost: 0,
                        total_operating_cost: 0,
                        net_profit: 0
                    },
                    {
                        name: "陕西", value: 0,
                        total_companies: 0,
                        total_companycount: 0,
                        total_individuals: 0,
                        total_register: 0,
                        bank_unit_price: 0,
                        total_company_profit: 0,
                        total_income: 0,
                        total_money: 0,
                        unit_cost: 0,
                        unit_profit: 0, total_partner_money: 0,
                        total_netprofit: 0,
                        cac: 0,
                        cpc: 0,
                        total_sales_personnel_cost: 0,
                        total_related_expenses: 0,
                        total_customer_personnel_cost: 0,
                        total_operating_cost: 0,
                        net_profit: 0
                    },
                    {
                        name: "青海", value: 0,
                        total_companies: 0,
                        total_companycount: 0,
                        total_individuals: 0,
                        total_register: 0,
                        bank_unit_price: 0,
                        total_company_profit: 0,
                        total_income: 0,
                        total_money: 0,
                        unit_cost: 0,
                        unit_profit: 0, total_partner_money: 0,
                        total_netprofit: 0,
                        cac: 0,
                        cpc: 0,
                        total_sales_personnel_cost: 0,
                        total_related_expenses: 0,
                        total_customer_personnel_cost: 0,
                        total_operating_cost: 0,
                        net_profit: 0
                    },
                    {
                        name: "黑龙江", value: 0,
                        total_companies: 0,
                        total_companycount: 0,
                        total_individuals: 0,
                        total_register: 0,
                        bank_unit_price: 0,
                        total_company_profit: 0,
                        total_income: 0,
                        total_money: 0,
                        unit_cost: 0,
                        unit_profit: 0,

                        total_partner_money: 0,
                        total_netprofit: 0,
                        cac: 0,
                        cpc: 0,
                        total_sales_personnel_cost: 0,
                        total_related_expenses: 0,
                        total_customer_personnel_cost: 0,
                        total_operating_cost: 0,
                        net_profit: 0
                    },
                    {
                        name: "四川", value: 0,
                        total_companies: 0,
                        total_companycount: 0,
                        total_individuals: 0,
                        total_register: 0,
                        bank_unit_price: 0,
                        total_company_profit: 0,
                        total_income: 0,
                        total_money: 0,
                        unit_cost: 0,
                        unit_profit: 0,

                        total_partner_money: 0,
                        total_netprofit: 0,
                        cac: 0,
                        cpc: 0,
                        total_sales_personnel_cost: 0,
                        total_related_expenses: 0,
                        total_customer_personnel_cost: 0,
                        total_operating_cost: 0,
                        net_profit: 0
                    },
                );
                this.topData = arr;
                console.log(this.topData, 'this.topDatathis.topData')
                this.initEchartMap();
            });
        },
        // 型地图初始化
        initEchartMap() {
            this.$echarts.registerMap("china", china);
            this.myChart = this.$echarts.init(this.$refs.mapChart, null, {
                renderer: "svg",
            });
            this.myChart.off("click");

            //echart 配制option
            var options = {
                tooltip: {
                    triggerOn: "mousemove", //mousemove、click
                    padding: 8,
                    borderWidth: 1,
                    borderColor: "#409eff",
                    backgroundColor: "rgba(255,255,255,0.7)",
                    textStyle: {
                        color: "#000000",
                        fontSize: 13,
                    },
                    formatter: function (e, t, n) {
                        let data = e.data;
                        let context = `
                            <div>
                                <p><b style="font-size:15px;">${data.name}</b></p>
                                <p class="tooltip_style"><span class="tooltip_left">总开户数量：</span><span class="tooltip_right">${data.value}</span></p>
                                <p class="tooltip_style"><span class="tooltip_left">总基础成本：</span><span class="tooltip_right">${data.total_money}</span></p>
                                <p class="tooltip_style"><span class="tooltip_left">合伙人提成：</span><span class="tooltip_right">${data.total_partner_money}</span></p>
                                <p class="tooltip_style"><span class="tooltip_left">公司毛利（包含合伙人）：</span><span class="tooltip_right">${data.total_company_profit}</span></p>
                                <p class="tooltip_style"><span class="tooltip_left">总收入：</span><span class="tooltip_right">${data.total_income}</span></p>
                                <p class="tooltip_style"><span class="tooltip_left">总毛利（扣除合伙人）：</span><span class="tooltip_right">${data.total_netprofit}</span></p>
                                <p class="tooltip_style"><span class="tooltip_left">新注册公司：</span><span class="tooltip_right">${data.total_companies}</span></p>
                                <p class="tooltip_style"><span class="tooltip_left">新注册个体户：</span><span class="tooltip_right">${data.total_individuals}</span></p>
                                <p class="tooltip_style"><span class="tooltip_left">新公司注册合计：</span><span class="tooltip_right">${data.total_register}</span></p>
                                <p class="tooltip_style"><span class="tooltip_left">财务公司数量：</span><span class="tooltip_right">${data.total_companycount}</span></p>
                                <p class="tooltip_style"><span class="tooltip_left">银行单价：</span><span class="tooltip_right">${data.bank_unit_price}</span></p>
                                <p class="tooltip_style"><span class="tooltip_left">单客基础成本：</span><span class="tooltip_right">${data.unit_cost}</span></p>
                                <p class="tooltip_style"><span class="tooltip_left">单客基础毛利：</span><span class="tooltip_right">${data.unit_profit}</span></p>
                                <p class="tooltip_style"><span class="tooltip_left">单客成本：</span><span class="tooltip_right">${data.cac}</span></p>
                                <p class="tooltip_style"><span class="tooltip_left">单客毛利：</span><span class="tooltip_right">${data.cpc}</span></p>
                                <p class="tooltip_style"><span class="tooltip_left">销售人员成本：</span><span class="tooltip_right">${data.total_sales_personnel_cost}</span></p>
                                <p class="tooltip_style"><span class="tooltip_left">相关费用：</span><span class="tooltip_right">${data.total_related_expenses}</span></p>
                                <p class="tooltip_style"><span class="tooltip_left">客服成本：</span><span class="tooltip_right">${data.total_customer_personnel_cost}</span></p>
                                <p class="tooltip_style"><span class="tooltip_left">运营成本合计：</span><span class="tooltip_right">${data.total_operating_cost}</span></p>
                                <p class="tooltip_style"><span class="tooltip_left">公司净利润：</span><span class="tooltip_right">${data.net_profit}</span></p>
                            </div>
                            `;
                        return context;
                    },
                },
                visualMap: {
                    show: true,
                    left: 26,
                    bottom: 40,
                    showLabel: true,
                    textStyle: {
                        color: "#ffffff",
                    },
                    pieces: [
                        {
                            gte: 5000,
                            label: ">= 5000",
                            color: "#070093",
                        },
                        {
                            gte: 1000,
                            lt: 4999,
                            label: "500 - 999",
                            color: "#1c3fbf",
                        },
                        {
                            gte: 500,
                            lt: 999,
                            label: "100 - 499",
                            color: "#1482e5",
                        },
                        {
                            gte: 100,
                            lt: 499,
                            label: "50 - 99",
                            color: "#70b4eb",
                        },
                        {
                            gte: 10,
                            lt: 99,
                            label: "10 - 50",
                            color: "#b4e0f3",
                        },
                        {
                            lt: 10,
                            label: "<10",
                            color: "#ffffff",
                        },
                    ],
                },
                geo: {
                    map: "china",
                    scaleLimit: {
                        min: 1,
                        max: 2,
                    },
                    zoom: 1,
                    top: 60,
                    layoutSize: "100%", //保持地图宽高比
                    label: {
                        normal: {
                            show: false,
                            fontSize: "12",
                            color: "rgba(0,0,0,0)",
                        },
                        emphasis: {
                            show: true,
                            position: "inside",
                            textStyle: {
                                color: "rgba(144,1,34,1)",
                            },
                        },
                    },
                    itemStyle: {
                        normal: {
                            //shadowBlur: 50,
                            //shadowColor: 'rgba(0, 0, 0, 0.2)',
                            borderColor: "rgba(0, 0, 0, 0.2)",
                            areaColor: "#1955a4",
                        },
                        emphasis: {
                            areaColor: "#f2d5ad",
                            shadowOffsetX: 0,
                            shadowOffsetY: 0,
                            borderWidth: 0,
                        },
                    },
                },
                series: [
                    {
                        name: "成果预览",
                        type: "map",
                        geoIndex: 0,
                        data: this.topData,
                    },
                ],
            };

            this.myChart.clear();
            this.myChart.setOption(options);
            this.myChart.resize();
            let that = this;
            //地图的点击事件 ，钻取到市我就不举例了，类似的方法，点击事件可以获取到当前点击的省份的数据；
            this.myChart.on("click", function (params) {
                console.log(params, '地图点击事件')
                if (params.value != 0) {
                    // that.dialogTableVisible4 = true;
                    that.selectProvincia = params;
                    that.mapProvinciaShow = true;
                    that.tableLoading = true
                    setTimeout(() => {
                        that.nextGetProvincialData()
                        that.getMonList()
                    }, 600)
                }
            });

            this.loading = false;

            // document.getElementById("mapChart")
        },

        nextGetProvincialData() {
            this.$nextTick(() => {
                this.getProvincialData();
            });
        },

        nextGetCityData() {
            this.$nextTick(() => {
                this.getCityData();
            });
        },

        closeMap() {
            if (this.mapCityShow)
                this.mapCityShow = false;
            else
                this.mapProvinciaShow = false;
            this.getMonList()
        },

        // 获取省一级数据
        getProvincialData() {
            let that = this
            console.log("获取省级数据，展示在弹窗上");
            this.tableLoading = true;
            let params = {
                province: this.selectProvincia.name
            }
            if (this.selectDate2 && this.selectDate2.length > 0) {
                params.start_date = this.selectDate2[0]
                params.end_date = this.selectDate2[1]
            }
            getMapCityIndex(params).then((res) => {
                this.provinceList = [];
                let pList = [];
                for (let val in res.data.data) {
                    let obj = {
                        name: res.data.data[val].city,
                        bank_count: res.data.data[val].bank_count,
                        value: res.data.data[val].company_count,
                        total_companies: res.data.data[val].total_companies,
                        total_companycount: res.data.data[val].total_companycount,
                        total_individuals: res.data.data[val].total_individuals,
                        total_register: res.data.data[val].total_register,
                        bank_unit_price: res.data.data[val].bank_unit_price,
                        total_company_profit: res.data.data[val].total_company_profit,
                        total_income: res.data.data[val].total_income,
                        total_money: res.data.data[val].total_money,
                        unit_cost: res.data.data[val].unit_cost,
                        unit_profit: res.data.data[val].unit_profit,

                        total_partner_money: res.data.data[val].total_partner_money,
                        total_netprofit: res.data.data[val].total_netprofit,
                        cac: res.data.data[val].cac,
                        cpc: res.data.data[val].cpc,
                        total_sales_personnel_cost: res.data.data[val].total_sales_personnel_cost,
                        total_related_expenses: res.data.data[val].total_related_expenses,
                        total_customer_personnel_cost: res.data.data[val].total_customer_personnel_cost,
                        total_operating_cost: res.data.data[val].total_operating_cost,
                        net_profit: res.data.data[val].net_profit
                    };
                    pList.push(val.city);
                    this.provinceList.push(obj);
                }
                if (this.provinceList.length > 0) {
                    let features =
                        this.provinciaList[this.selectProvincia.name].features;
                    for (let item of features) {
                        if (!pList.includes(item.properties.name)) {
                            this.provinceList.push({
                                name: item.properties.name,
                                value: 0,
                                bank_count: 0,
                                total_companies: 0,
                                total_companycount: 0,
                                total_individuals: 0,
                                total_register: 0,
                                bank_unit_price: 0,
                                total_company_profit: 0,
                                total_income: 0,
                                total_money: 0,
                                unit_cost: 0,
                                unit_profit: 0,

                                total_partner_money: 0,
                                total_netprofit: 0,
                                cac: 0,
                                cpc: 0,
                                total_sales_personnel_cost: 0,
                                total_related_expenses: 0,
                                total_customer_personnel_cost: 0,
                                total_operating_cost: 0,
                                net_profit: 0

                            });
                        }
                    }
                    this.$echarts.registerMap(
                        "provincia",
                        this.provinciaList[this.selectProvincia.name]
                    );
                    this.myChartProvincia = this.$echarts.init(
                        this.$refs.mapProvincia,
                        null,
                        {
                            renderer: "svg",
                        }
                    );
                    this.myChartProvincia.off("click");

                    var options = {
                        tooltip: {
                            triggerOn: "mousemove", //mousemove、click
                            padding: 8,
                            borderWidth: 1,
                            borderColor: "#409eff",
                            backgroundColor: "rgba(255,255,255,0.7)",
                            textStyle: {
                                color: "#000000",
                                fontSize: 13,
                            },
                            formatter: function (e, t, n) {
                                let data = e.data;
                                let context = `
                            <div>
                                <p><b style="font-size:15px;">${data.name}</b></p>
                                <p class="tooltip_style"><span class="tooltip_left">总开户数量：</span><span class="tooltip_right">${data.value}</span></p>
                                <p class="tooltip_style"><span class="tooltip_left">总基础成本：</span><span class="tooltip_right">${data.total_money}</span></p>
                                <p class="tooltip_style"><span class="tooltip_left">合伙人提成：</span><span class="tooltip_right">${data.total_partner_money}</span></p>
                                <p class="tooltip_style"><span class="tooltip_left">公司毛利（包含合伙人）：</span><span class="tooltip_right">${data.total_company_profit}</span></p>
                                <p class="tooltip_style"><span class="tooltip_left">总收入：</span><span class="tooltip_right">${data.total_income}</span></p>
                                <p class="tooltip_style"><span class="tooltip_left">总毛利（扣除合伙人）：</span><span class="tooltip_right">${data.total_netprofit}</span></p>
                                <p class="tooltip_style"><span class="tooltip_left">新注册公司：</span><span class="tooltip_right">${data.total_companies}</span></p>
                                <p class="tooltip_style"><span class="tooltip_left">新注册个体户：</span><span class="tooltip_right">${data.total_individuals}</span></p>
                                <p class="tooltip_style"><span class="tooltip_left">新公司注册合计：</span><span class="tooltip_right">${data.total_register}</span></p>
                                <p class="tooltip_style"><span class="tooltip_left">财务公司数量：</span><span class="tooltip_right">${data.total_companycount}</span></p>
                                <p class="tooltip_style"><span class="tooltip_left">银行单价：</span><span class="tooltip_right">${data.bank_unit_price}</span></p>
                                <p class="tooltip_style"><span class="tooltip_left">单客基础成本：</span><span class="tooltip_right">${data.unit_cost}</span></p>
                                <p class="tooltip_style"><span class="tooltip_left">单客基础毛利：</span><span class="tooltip_right">${data.unit_profit}</span></p>
                                <p class="tooltip_style"><span class="tooltip_left">单客成本：</span><span class="tooltip_right">${data.cac}</span></p>
                                <p class="tooltip_style"><span class="tooltip_left">单客毛利：</span><span class="tooltip_right">${data.cpc}</span></p>
                                <p class="tooltip_style"><span class="tooltip_left">销售人员成本：</span><span class="tooltip_right">${data.total_sales_personnel_cost}</span></p>
                                <p class="tooltip_style"><span class="tooltip_left">相关费用：</span><span class="tooltip_right">${data.total_related_expenses}</span></p>
                                <p class="tooltip_style"><span class="tooltip_left">客服成本：</span><span class="tooltip_right">${data.total_customer_personnel_cost}</span></p>
                                <p class="tooltip_style"><span class="tooltip_left">运营成本合计：</span><span class="tooltip_right">${data.total_operating_cost}</span></p>
                                <p class="tooltip_style"><span class="tooltip_left">公司净利润：</span><span class="tooltip_right">${data.net_profit}</span></p>
                            </div>
                            `;
                                return context;
                            },
                        },
                        visualMap: {
                            show: true,
                            left: 26,
                            bottom: 40,
                            showLabel: true,
                            textStyle: {
                                color: "#ffffff",
                            },
                            pieces: [
                                {
                                    gte: 1000,
                                    label: ">= 1000",
                                    color: "#a50026",
                                },
                                {
                                    gte: 500,
                                    lt: 999,
                                    label: "500 - 999",
                                    color: "#d73027",
                                },
                                {
                                    gte: 200,
                                    lt: 499,
                                    label: "299 - 499",
                                    color: "#f46d43",
                                },
                                {
                                    gte: 100,
                                    lt: 199,
                                    label: "100 - 499",
                                    color: "#fdae61",
                                },
                                {
                                    gte: 50,
                                    lt: 99,
                                    label: "50 - 99",
                                    color: "#fee090",
                                },
                                {
                                    gte: 1,
                                    lt: 49,
                                    label: "< 50",
                                    color: "#ffffbf",
                                },
                                {
                                    lt: 1,
                                    label: "0",
                                    color: "#e0f3f8",
                                },
                            ],
                        },
                        geo: {
                            map: "provincia",
                            scaleLimit: {
                                min: 1,
                                max: 2,
                            },
                            zoom: 1.2,
                            top: 60,
                            layoutSize: "100%", //保持地图宽高比
                            label: {
                                normal: {
                                    show: false,
                                    fontSize: "12",
                                    color: "rgba(0,0,0,0)",
                                },
                                emphasis: {
                                    show: true,
                                    position: "inside",
                                    textStyle: {
                                        color: "rgba(144,1,34,1)",
                                    },
                                },
                            },
                            itemStyle: {
                                normal: {
                                    //shadowBlur: 50,
                                    //shadowColor: 'rgba(0, 0, 0, 0.2)',
                                    borderColor: "rgba(0, 0, 0, 0.2)",
                                    areaColor: "#1955a4",
                                },
                                emphasis: {
                                    areaColor: "#f2d5ad",
                                    shadowOffsetX: 0,
                                    shadowOffsetY: 0,
                                    borderWidth: 0,
                                },
                            },
                        },
                        series: [
                            {
                                name: "成果预览",
                                type: "map",
                                geoIndex: 0,
                                data: this.provinceList,
                            },
                        ],
                    };

                    this.myChartProvincia.clear();
                    this.myChartProvincia.setOption(options);
                    this.myChartProvincia.resize();
                    let that = this;
                    //地图的点击事件 ，钻取到市我就不举例了，类似的方法，点击事件可以获取到当前点击的省份的数据；
                    this.myChartProvincia.on("click", function (params) {
                        console.log(params, 'paramsparamsparams')
                        if (params.data.bank_count != 0) {
                            // that.dialogTableVisible5 = true;
                            that.selectCity = params;
                            that.mapCityShow = true;
                            setTimeout(() => {
                                that.nextGetCityData()
                                that.getMonList()
                            }, 600)
                        }

                    });
                    this.tableLoading = false;
                } else {
                    this.tableLoading = false;
                }
            });
        },

        // 获取市一级数据
        async getCityData() {
            this.tableLoading2 = true
            let params = {
                city: this.selectCity.name
            }
            if (this.selectDate2 && this.selectDate2.length > 0) {
                params.start_date = this.selectDate2[0]
                params.end_date = this.selectDate2[1]
            }
            const res = await getCityBankData_new(params)
            if (res.data.code == 1) {
                this.cityOptions.series = []
                for (let key in res.data.data) {
                    if (res.data.data[key].length > 0) {
                        let arr = []
                        for (let val in res.data.data[key]) {
                            let obj = {
                                name: res.data.data[key][val].bank_name,
                                value: [res.data.data[key][val].lng, res.data.data[key][val].lat, res.data.data[key][val].count]
                            }
                            arr.push(obj)
                        }
                        this.cityOptions.series.push({
                            name: this.bankDictionary[key].name,
                            data: arr,
                            type: 'scatter',
                            coordinateSystem: 'geo',
                            encode: {
                                value: 2
                            },
                            symbolSize: 20,
                            label: {
                                formatter: function (params) {
                                    return params.data.value[2];
                                },
                                position: 'right',
                                show: true,
                            },
                            itemStyle: {
                                color: this.bankDictionary[key].color
                            },
                            emphasis: {
                                label: {
                                    show: false
                                }
                            }
                        })

                    }
                }

                const cityId = cityMap[this.selectCity.name];
                const json = await getMapJson({
                    city: cityId,
                })

                this.cityJSON = JSON.parse(json.data.data)

                this.$echarts.registerMap(this.selectCity.name, this.cityJSON)

                this.cityOptions.geo.map = this.selectCity.name
                this.myChartCtiy = this.$echarts.init(document.getElementById('mapCity'))
                this.myChartCtiy.setOption(this.cityOptions);
            }


        },





























        getCityListData() {
            getCityList().then(res => {
                if (res.data.code == 1) {
                    this.regionData = res.data.data
                }
            })
        },

        cityChange(e) {
            console.log(e)
            this.cityValue = e[1]
            this.getMonList()
        },

        // 获取对于时间范围用户活跃数据
        getuseractivedata(e = null) {
            console.log(e);
            this.loading = true
            if (!e)
                var obj = {
                    start_date: this.selectDate[0],
                    end_date: this.selectDate[1],
                };
            else
                var obj = {
                    start_date: e[0],
                    end_date: e[1],
                };
            getKaihuList(obj).then((res) => {
                this.loading = false
                console.log(res);
                let xData = [];
                let deal = [];
                let yuyue = [];
                res.data.data.forEach((val) => {
                    xData.push(val.date);
                    deal.push(val.deal);
                    yuyue.push(val.yuyue);

                });
                this.lineOpiton.xAxis.data = xData;
                this.lineOpiton.series[0].data = yuyue;
                this.lineOpiton.series[1].data = deal;
                this.$echarts
                    .init(document.getElementById("dayActive"))
                    .setOption(this.lineOpiton);
            });
        },


        // 获取对于时间范围用户活跃数据
        async getMonList() {
            this.loading2 = true
            console.log(this.selectDate2, 'selectDate2')
            let obj = {
                start_date: this.selectDate2[0],
                end_date: this.selectDate2[1],
            };
            if (this.mapProvinciaShow) {
                for (let item of region) {
                    if (item.name.includes(this.selectProvincia.name)) obj.province = item.name
                }
            }
            if (this.mapCityShow) obj.city = this.selectCity.name

            const res = await getKaihuCityList(obj)
            this.loading2 = false
            let xData = [];
            let yuyue = []
            let deal = []
            res.data.data.forEach(val => {
                xData.push(val.date);
                yuyue.push(val.yuyue)
                deal.push(val.deal)
            })
            this.lineOpiton2.xAxis.data = xData;
            this.lineOpiton2.series[0].data = yuyue;
            // this.lineOpiton2.series[1].data = deal;
            this.$echarts
                .init(document.getElementById("monActive"))
                .setOption(this.lineOpiton2);
        },

        getWebSocket() {
            this.$goeasy.connect({
                onSuccess: function () {
                    //连接成功
                    console.log("GoEasy connect successfully."); //连接成功
                },
                onFailed: function (error) {
                    //连接失败
                    console.log(
                        "Failed to connect GoEasy, code:" +
                        error.code +
                        ",error:" +
                        error.content
                    );
                },
                onProgress: function (attempts) {
                    //连接或自动重连中
                    console.log("GoEasy is connecting", attempts);
                },
            });
            let pubsub = this.$goeasy.pubsub;
            let _that = this;
            pubsub.subscribe({
                channel: "screen_channel", //替换为您自己的channel
                onMessage: function (message) {
                    console.log("是否能从服务端主动接收到消息");
                    _that.scrollView = !_that.scrollView;
                },
                onSuccess: function () {
                    console.log("Channel订阅成功。");
                },
                onFailed: function (error) {
                    console.log(
                        "Channel订阅失败, 错误编码：" +
                        error.code +
                        " 错误信息：" +
                        error.content
                    );
                },
            });
        },
    },
};
</script>

<style lang="scss">
@import "@/styles/home.scss";
@import "@/styles/common.scss";

.header-cell {
    color: #61d2f7 !important;
    font-size: 14px;
    font-weight: 600;
    height: 48px;
    background-color: #072951 !important;
    box-shadow: -10px 0px 15px #034c6a inset, 10px 0px 15px #034c6a inset;
}

.row-cell {
    color: #fff !important;
    background-color: #072951 !important;
}

.row-cells {
    color: #fff !important;
    background-color: #072951 !important;
    box-shadow: -10px 0px 15px #034c6a inset, 10px 0px 15px #034c6a inset;
}

.chart-two {
    padding-top: 20px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    height: calc(100vh - 80px);
    .line-chart {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;
    }
}

.picker-list {
    display: flex;
    align-items: center;
}
</style>
